import Chip from '@/atoms/chips/Chip';
import EntityChip from '@/atoms/chips/EntityChip';
import Paragraph from '@/atoms/typography/Paragraph';
import Size from '@enums/Size';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

const skillColorProps = (color) => {
  return {
    normal: {
      backgroundColor: color.primary,
      color: color.tertiary,
    },
    focus: {
      backgroundColor: color.primary,
      color: color.tertiary,
    },
    hover: {
      backgroundColor: color.primary,
      color: color.tertiary,
    },
  };
};

const SkillLabel = ({ item }) => {
  const { label, type, props } = item;

  const colors = props.colors || props.color;
  const colorProps = colors ? skillColorProps(colors) : null;
  const parentEntity = item.parentType || props.parent?.type;

  return (
    <>
      <Stack direction="row" spacing={0.5}>
        {props.scope && <EntityChip type={props.scope} size={Size.XX_SMALL} />}
        {parentEntity && (
          <EntityChip type={parentEntity} size={Size.XX_SMALL} />
        )}
        {props.parent && (
          <Chip
            id={item.id}
            colorProps={colorProps}
            name={label.toUpperCase()}
            size={Size.XX_SMALL}
            fontWeight={600}
          />
        )}
      </Stack>
      {props.parent && (
        <Paragraph size={Size.SMALL} overrideStyles={{ mb: 0, mt: 1 }}>
          {props.parent.name}
        </Paragraph>
      )}
      {!props.parent && (
        <Box mt={0.75}>
          <Chip
            id={item.id}
            colorProps={colorProps}
            name={label.toUpperCase()}
            size={Size.X_SMALL}
            fontWeight={600}
          />
        </Box>
      )}
    </>
  );
};

export default SkillLabel;
